import { createReducer, on } from '@ngrx/store';
import * as modulesActions from '../actions/modules.actions'

export interface ModuleState {
  entities: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: ModuleState = {
  entities: {},
  loaded: false,
  loading: false
};

const modulesReducer = createReducer(
  initialState,
  on(modulesActions.LoadModules, state => ({...state, loading: true })),
  on(modulesActions.LoadModulesSuccess, (state, { payload }) => {
    const entities = payload;
    return { ...state, loading: false, loaded: true, entities}
  }),
  on(modulesActions.LoadModulesFail, state => ({...state, loading: false, loaded: false })),
)

export function reducer(state, action) {
  return modulesReducer(state, action)
}

export const getModulesEntities = (state: ModuleState) => state?.entities;
export const getModulesLoading = (state: ModuleState) => state?.loading;
export const getModulesLoaded = (state: ModuleState) => state?.loaded;
